import {Exclude, Expose, plainToInstance, Type} from "class-transformer";
import * as t from "io-ts";
import {ContainerLevelHistoryArrayValidator, ContainerLevelHistoryEntity} from "./container-level-history";
import {TransportArrayValidator, TransportEntity} from "./transport";
import {ContainerArrayCodec, ContainerEntity} from "./container";

/** Validator for a container level history type value. */
export const ContainerLevelHistoryHolderValidator = t.intersection([
  t.type({}),
  t.partial({
    transportList: TransportArrayValidator,
    containerLevelHistoryList: ContainerLevelHistoryArrayValidator,
    containerList: ContainerArrayCodec,
  }),
]);

export const ContainerLevelHistoryHolderArrayValidator = t.array(ContainerLevelHistoryHolderValidator);

export type ContainerLevelHistoryHolder = t.TypeOf<typeof ContainerLevelHistoryHolderValidator>;
export type ContainerLevelHistoryHolderArray = t.TypeOf<typeof ContainerLevelHistoryHolderArrayValidator>;

/**
 * A container level history.
 */
@Exclude()
export class ContainerLevelHistoryHolderEntity {

  @Expose({name: "transportList"})
  @Type(() => TransportEntity)
  transports: TransportEntity[] = [];

  @Expose({name: "containerLevelHistoryList"})
  @Type(() => ContainerLevelHistoryEntity)
  containerLevels: ContainerLevelHistoryEntity[] = [];

  @Expose({name: "containerList"})
  @Type(() => ContainerEntity)
  containers: ContainerEntity[] = [];

  /**
   * Constructor for ContainerLevelHistoryEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(holder: ContainerLevelHistoryHolder): ContainerLevelHistoryHolderEntity {
    return plainToInstance(ContainerLevelHistoryHolderEntity, holder, {
      excludeExtraneousValues: true
    });
  }
}
